import {
  RadioButtonGroupMapping,
  RadioButtonType,
} from '@labrav/react-components'

export const renewalOptions: RadioButtonGroupMapping[] = [
  {
    key: 'Yes',
    label: 'Yes',
    type: RadioButtonType.STANDARD,
  },
  {
    key: 'No',
    label: 'No',
    type: RadioButtonType.STANDARD,
  },
]

export const channelTypes: RadioButtonGroupMapping[] = [
  {
    key: 'EXTERNAL',
    label: 'Existing customer moving to AWS Marketplace',
    type: RadioButtonType.STANDARD,
  },
  {
    key: 'AWS_MARKETPLACE',
    label: 'Existing customer on AWS Marketplace',
    type: RadioButtonType.STANDARD,
  },
]

export const renewalTypes: RadioButtonGroupMapping[] = [
  {
    key: 'RENEWAL',
    label:
      'This is a renewal for an existing customer, and I attest to the above statement as true',
    type: RadioButtonType.STANDARD,
  },
  {
    key: 'NEW',
    label: 'This is not a customer renewal',
    type: RadioButtonType.STANDARD,
  },
]

export const dealTypes: RadioButtonGroupMapping[] = [
  {
    key: 'NEW',
    label: 'New - deals that are net-new bussiness',
    type: RadioButtonType.STANDARD,
  },
  {
    key: 'CHANNEL_SHIFT',
    label:
      'Channel shift - deals moves from partner paper to marketplace (workload already on Google cloud)',
    type: RadioButtonType.STANDARD,
  },
  {
    key: 'MIGRATION',
    label:
      'Migration - new Google cloud workload (deals move from on-prem or other hyperscalers to Google cloud)',
    type: RadioButtonType.STANDARD,
  },
  {
    key: 'NATIVE_RENEWAL',
    label: 'Native renewal - deals that are renewing on the marketplace',
    type: RadioButtonType.STANDARD,
  },
]

export const microsoftRenewalResourceLink =
  'https://learn.microsoft.com/en-gb/partner-center/marketplace-offers/agency-fee-discount-for-renewals'

export const gcpRenewalLink =
  'https://cloud.google.com/terms/marketplace-revenue-share-schedule?e=13802955&hl=en'
